import React, { FC } from "react";

import { Icon, SimpleLoader } from "ui-library/atoms";

import { FileItem } from "types";

import { getIsAnyFileItemPending, getIsSuccessUploadStateInEveryFileItem } from "../util";

interface FileItemsStatusProps {
    fileItems: FileItem[];
}

export const FileItemsStatus: FC<FileItemsStatusProps> = ({ fileItems }) => {
    if (!fileItems || fileItems.length === 0) {
        return null;
    }

    if (getIsAnyFileItemPending(fileItems)) {
        return <SimpleLoader loading />;
    }

    const hasErrors = !getIsSuccessUploadStateInEveryFileItem(fileItems);
    const iconProps = {
        size: 16,
        color: hasErrors ? "red" : "green",
        icon: hasErrors ? "circle-error" : "circle-check",
    };

    return <Icon {...iconProps} />;
};
